<!--
  Commented due to panel added from drupal, but not deleted for future use
  <app-live-events-panel *ngIf="expected_model.itemsLive && expected_model.itemsLive.length>0 && expected_model.loadingLive === false; else loadingLive"
  [events]="expected_model.itemsLive"></app-live-events-panel>
<ng-template #loadingLive>
  <div *ngIf="expected_model.itemsLive.length!==0" class="status-message status-message--info" class="loading-throbber"></div>
</ng-template>
-->

<h2>
  <span>{{
    (
    filter_service.filtersType[1].options.options_selected_subject.asObservable()
    | async
    )?.name | transloco
    }}
  </span>
</h2>
<table class="wa-table">
  <thead class="wa-table__header-group">
    <tr class="wa-table__row">
      <th></th>
      <th class="h-ranking sortable wa-table__cell" [ngClass]="sortClass('NAME')" (click)="changeSort('NAME')">
        <span>{{'Name' | transloco}}</span>
      </th>
      <th class="h-name sortable wa-table__cell" [ngClass]="sortClass('NOC')" (click)="changeSort('NOC')">
        <span>
          {{'Location' | transloco}}
        </span>
      </th>

      <th class="h-points sortable wa-table__cell" [ngClass]="sortClass('DATE')" (click)="changeSort('DATE')">
        <span>{{'Date' | transloco}}</span>
      </th>
      <th></th>
      <th></th>
    </tr>
  </thead>

  <ng-container *ngIf="data.length > 0">
    <tbody class="wa-table__row-group" *ngFor="let Event of data" [event]="Event" event-item class="wa-table__row-group">
    </tbody>
  </ng-container>

  <ng-template #noresults>
      <tbody class="wa-table__row-group">
        <div *ngIf="loading===false" class="status-message status-message--info">{{'no_results' | transloco}}
          {{(defaultValueMessage|async) | transloco}}</div>
      </tbody>
    </ng-template>
</table>

<app-load-more-button *ngIf="data!==undefined &&  data.length!==0; else noresults" (loadMore)="loadMore()" [loading]="loading" [areMoreData]="areMoreData()"></app-load-more-button>

<hr class="spacer" />
